import { findPatientResult } from "@/lib/patient-results";

// Thin "results image" posts imported from the old WordPress blog (category
// js-results). They held nothing but a graft count and a client name, so they
// were removed from the blog. Their old root-level URLs 301 to the real
// results content: the matching endorser page where one exists, otherwise the
// results gallery. The endorser routes under /results/* are unaffected.

const ENDORSER_SLUGS = new Set([
  "brian-urlacher",
  "bryan-bickell",
  "danny-kanell",
  "deion-sanders",
  "ian-happ",
  "jim-cornelison",
  "kevin-streelman",
  "kevin-vandam",
  "matt-forte",
  "mike-bibby",
  "pat-hoberg",
  "zach-johnson",
]);

const CLIENT_SLUGS = new Set([
  "adam-a", "anthony-c", "artur-l", "bill-p", "bora-g", "brandon-h", "brent-l",
  "brian-s", "bryan-b", "chris-e", "chris-l", "christopher-r", "claus-r",
  "darrell-w", "dave-s", "dean-d", "donnie-b", "drew-j", "eddie-m", "edwin-w",
  "enrique-b", "erik-g", "gino-t", "ian-m", "jake-k", "jake-w", "james-d",
  "james-l", "james-w", "jamie-s", "jason-c", "jeremy-a", "joe-t", "john-a",
  "john-k", "jonathan-s", "jordan-s", "joseph-b", "joseph-s", "josh-k",
  "juanito-q", "kevin-b", "lance-w", "larry-y", "logan-s", "martin-b",
  "michael-s", "mitch-c", "nick-g", "noah-o", "ray-v", "richard-s", "rick-m",
  "robby-h", "robert-burns", "robert-l", "ryan-d", "ryan-e", "steve-c",
  "steve-p", "tim-b", "tim-c", "todd-d", "tom-c", "tommy-b", "tony-l",
  "varun-k", "will-r", "willie-c",
]);

/** Returns the 301 target for a retired results-image post, or null. */
export function legacyResultsRedirect(slug: string): string | null {
  if (ENDORSER_SLUGS.has(slug)) return `/results/${slug}/`;
  // Patient posts rebuilt as their own page (patient-results.ts).
  if (findPatientResult(slug)) return `/results/${slug}/`;
  if (CLIENT_SLUGS.has(slug)) return "/results/";
  return null;
}
